export default {
  namespaced: true,
  state: {
    delimiter: 'Comma',
    selectedFile: null,
    csv_header: [],
    import_type: 'file',
    file_id: null,
    rows: null
  },
  mutations: {
    'delimiter': (state, value) => {
      state.delimiter = value;
    },
    'selectedFile':(state,value)=>{
      state.selectedFile = value;
    },
    'csv_header': (state, value) => {
      state.csv_header = value;
    },
    'import_type':(state,value)=>{
      state.import_type = value;
    },
    'file_id':(state,value)=>{
      state.file_id = value;
    },
    'rows':(state,value)=>{
      state.rows = value;
    }
  },
  getters: {
    delimiter: state => state.delimiter,
    selectedFile: state => state.selectedFile,
    csv_header: state => state.csv_header,
    import_type: state => state.import_type,
    file_id: state => state.file_id,
    rows: state => state.rows
  },
  actions:{
    resetStore ({ commit }) {
      commit('delimiter', 'Comma')
      commit('selectedFile', null)
      commit('csv_header', [])
      commit('import_type', 'file')
      commit('file_id', null)
      commit('rows', null)
    }
  }
}